
import request from '@/utils/request.js'


export function indexQuery(parameter) {
  return request({
    url: '/student/my/indexQuery',
    method: 'post',
    params: parameter
  })
}

export function schoolIdSetting(parameter) {
  return request({
    url: '/student/my/schoolIdSetting',
    method: 'post',
    params: parameter
  })
}


export function queryAndUpdateSession(parameter) {
  return request({
    url: '/student/my/queryAndUpdateSession',
    method: 'post',
    params: parameter
  })
}


